import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router'
import { tagHotjarRecording } from '../../helpers/util'

import { logErrorOnServer } from '../../helpers/serverLogging'
import useFleet from '../../hooks/useFleet'
import useAuth from '../../hooks/useAuth'
import AppRoutes from '../../routes/appRoutes'
import ContentLayout from '../../components/ContentLayout/ContentLayout'
import MainHeading from '../../components/MainHeading/MainHeading'
import Button from '../../components/Button/Button'
import CardInfo from '../../components/CardInfo/CardInfo'
import InputText from '../../components/InputText/InputText'
import DropDown from '../../components/DropDown/DropDown'
import DropDownWithSearch from '../../components/DropDownWithSearch/DropDownWithSearch'
import CustomDivider from '../../components/CardInfo/components/CustomDivider'
import CellLocation from '../../components/Table/components/CellLocation'
import UploadImage from './components/UploadImage'
import UploadAsset from '../../svg/UploadAsset.svg'
import UploadPlatePhoto from '../../svg/UploadPlatePhoto.svg'
import useGlobalLoading from '../../hooks/useGlobalLoading'
import useUploadFile from '../../hooks/useUploadFile'
import useAlert from '../../hooks/useAlert'
import { isEmpty } from 'lodash'
import { useFormik } from 'formik'
import { getInitialValues, validationSchema } from '../../forms/CreateAssetForm'
import useScreen from '../../hooks/useScreen'
import { useNetworkStatus } from '../../utils/networkStatus'


const classOptionsList = [
    'Aerial Lifts',
    'Automations',
    // 'Batteries',
    // 'Chargers',
    'Forklifts',
    'Pallet Trucks',
    'Rail and Transit',
    'Warehouse Vehicles and Operated Machinery',
    'Warehouse Accessories',
]

const fuelTypeOptionsList = [
    'Diesel',
    'Dual Fuel',
    'Electric',
    'Gasoline',
    'LPG',
    'N/A',
]

const logError = logErrorOnServer('Create Asset')

const CreateAssetPage = props => {
    const { history } = props

    const [manufacturerList, setManufacturerList] = useState([])
    const [modelByManufacturers, setModelsByManufacturers] = useState([])
    const [modelList, setModelList] = useState([])
    const [isManufacturerFromList, setIsManufacturerFromList] = useState(true)
    const [isModelFromList, setIsModelFromList] = useState(true)

    const { isOffline } = useNetworkStatus()

    // Revisar esto, puede que no tenga que hacer esto
    const manufacturerOptions = manufacturerList

    const modelOptions = modelList?.map((i, index) => ({
        value: i,
        id: index,
    }))

    const classOptions = classOptionsList?.map((i, index) => ({
        value: i,
        id: index,
    }))

    const fuelTypeOptions = fuelTypeOptionsList?.map((i, index) => ({
        value: i,
        id: index,
    }))
    const serialNumberToTriggerServiceRequest = undefined

    const [files, setFiles] = useState([])
    const [photos, setPhotos] = useState([])
    const [error, setError] = useState(null)
    const [imageRetryAttempted, setImageRetryAttempted] = useState(false)
    const { handleCreateAsset, handleGetMakeAndModel } = useFleet()
    const { user, impersonatedBy } = useAuth()
    const { changeLoading } = useGlobalLoading()
    const { handleUpdateFile } = useUploadFile()
    const { handleChangeAlert } = useAlert()
    const { isMobile } = useScreen()

    const initialValues = getInitialValues(user)

    const {
        handleSubmit,
        getFieldProps,
        errors,
        isValid,
        touched,
        values,
        setFieldValue,
        resetForm,
    } = useFormik({
        initialValues: initialValues,
        validationSchema,
        onSubmit: formValues => {
            handleCreateAssetFunc(formValues)
        },
    })

    useEffect(() => {
        if (values['manufacturer']) {
            const selectedMake = values['manufacturer']
            const make = manufacturerList.find(manufacturer => manufacturer.value === selectedMake)
            let models = []
            if (make) {
                // Model value reset when the manufacturer comes from the list
                values['model'] = ''
                values['isMakeFromList'] = true
                values['isModelFromList'] = true

                models = Object.values(modelByManufacturers[make?.idName])
            } else {
                // If the manufacturer is from a list then the model too
                setIsManufacturerFromList(false)
                values['isMakeFromList'] = false
            }

            setModelList(models)
        }
    }, [values['manufacturer']])

    const onGetMakeModelSuccess = response => {
        const manufacturers = response?.data?.manufacturer
        const modelsByManufacturer = response?.data?.models
        setManufacturerList(manufacturers)
        setModelsByManufacturers(modelsByManufacturer)
        changeLoading(false)
    }

    const onGetMakeModelError = response => {
        console.log('Error', response)
        changeLoading(false)
    }

    useEffect(() => {
        if (manufacturerList.length == 0 && !isOffline) {
            changeLoading(true)
            handleGetMakeAndModel(onGetMakeModelSuccess, onGetMakeModelError)
        }
    }, [])

    useEffect(() => {
        if (error != null || !isEmpty(error)) {
            handleChangeAlert({
                title: 'Error',
                message: error,
                type: 'error',
            })
        }
    }, [error])

    useEffect(() => {
        if (files?.length > 0) {
            files?.forEach(item => {
                if (!item?.uplaoded) {
                    if (item?.file) {
                        const formData = new FormData()
                        formData.append('file', item?.file)
                        changeLoading(true)
                        handleUpdateFile(
                            formData,
                            handleImageSuccess,
                            handleImageError,
                            item?.type,
                        )
                    }
                }
            })
        }
    }, [files])

    const selectOptions = user?.locationPreferences

    const setMakeOffList = (value) => {
        setIsManufacturerFromList(value)
        values['model'] = ''
        values['manufacturer'] = ''
        values['isMakeFromList'] = value
        setModelList([])

    }

    const setModelOffList = (value) => {
        setIsModelFromList(value)
        values['isModelFromList'] = value
    }

    const onCreatedAssetSuccess = response => {
        const createdWithoutImage = response?.data?.createdWithoutImage

        handleChangeAlert({
            title: 'Asset Saved',
            message: createdWithoutImage
                ? 'The asset was created, but the image could not be processed and was not included.'
                : 'Please note new assets may not appear in the fleet list immediately.',
            type: 'success',
        })
        changeLoading(false)
        setImageRetryAttempted(false)
        resetForm({
            values: initialValues,
        })
        setFiles([])
        setPhotos([])
    }

    const onCreatedAssetError = error => {
        tagHotjarRecording('API Error')
        const {
            imageFailed,
            imageRetryAttempted: shouldRetryImage,
            message = 'Please check your internet connection and try again.',
        } = error?.response?.data ?? {}

        if (imageFailed && shouldRetryImage) {
            setImageRetryAttempted(true)
        }

        setError(message)
        changeLoading(false)
        logError(message)
    }

    const hasPendingUploads = files.some(
        item => item?.file && !item?.uplaoded,
    )

    const handleCreateAssetFunc = formValues => {
        if (hasPendingUploads) {
            setError('Please wait for image uploads to finish.')
            return
        }

        const assetInfo = { photos, imageRetryAttempted, ...formValues }
        changeLoading(true)
        handleCreateAsset(assetInfo, onCreatedAssetSuccess, onCreatedAssetError)
    }

    const handleImageSuccess = (result, type) => {
        setPhotos(prev => [
            ...prev.filter(item => item?.type !== type),
            { filename: result?.data?.filename, type },
        ])
        setFiles(prev =>
            prev?.map(item => {
                if (item?.type === type) {
                    return {
                        ...item,
                        uplaoded: true,
                    }
                }
                return item
            }),
        )
        setError(null)
        setImageRetryAttempted(false)
        changeLoading(false)
    }

    const handleImageError = result => {
        const errorMessage =
            result.toString().indexOf('File is too large') > -1
                ? 'File is too large. 8MB Max'
                : result.toString().indexOf('422') > -1
                    ? result.toString().substring(10)
                    : 'Unable to upload file.'
        setError(errorMessage)
        logError(errorMessage)
        changeLoading(false)
    }

    const addImage = (file, type) => {
        setImageRetryAttempted(false)
        setPhotos(prev => prev.filter(item => item?.type !== type))

        const alreadyExists = files?.find(i => i?.type === type)
        if (alreadyExists) {
            setFiles(
                files?.map(fil => {
                    if (fil?.type === type) {
                        return {
                            ...fil,
                            file: file,
                            uplaoded: false,
                        }
                    }
                    return fil
                }),
            )
        } else {
            setFiles([
                ...files,
                {
                    file: file,
                    type: type,
                },
            ])
        }
    }

    const removeImage = type => {
        setImageRetryAttempted(false)
        setFiles(files?.filter(f => f?.type !== type))
        setPhotos(photos?.filter(item => item?.type !== type))
    }

    const getImage = type => {
        return files?.find(i => (i?.type === type) & i?.uplaoded) || null
    }

    if (serialNumberToTriggerServiceRequest) {
        return (
            <Redirect
                to={AppRoutes.createRequests(
                    serialNumberToTriggerServiceRequest,
                )}
            />
        )
    }

    const formattedShiptos = selectOptions?.map(item => {
        return {
            ...item,
            locationToShow: (
                <CellLocation
                    isInCard
                    label={item?.label}
                    address={item?.address}
                />
            ),
        }
    })

    const disableModelInput = isManufacturerFromList ? values['manufacturer'] === "" : false

    const renderForm = () => {
        return (
            <div className="w-full h-auto lg:p-8 p-4 lg:pb-4 pb-0 flex flex-col items-start justify-start">
                <div className="w-full h-auto flex lg:flex-row flex-col items-center justify-between gap-x-8 gap-y-6">
                    <UploadImage
                        text="Upload Asset Photo"
                        icon={
                            <img className="object-cover" src={UploadAsset} />
                        }
                        file={getImage('asset')?.file}
                        setFile={file => addImage(file, 'asset')}
                        onRemove={() => removeImage('asset')}
                    />
                    <UploadImage
                        text="Upload Data Plate Photo"
                        icon={
                            <img
                                className="object-cover"
                                src={UploadPlatePhoto}
                            />
                        }
                        file={getImage('dataplate')?.file}
                        setFile={file => addImage(file, 'dataplate')}
                        onRemove={() => removeImage('dataplate')}
                    />
                </div>
                <CustomDivider />
                <div className="w-full flex  lg:flex-row flex-col items-center justify-between gap-x-8 gap-y-1">
                    <InputText
                        {...getFieldProps('customerUnitNumber')}
                        placeholder="Your name or number for this asset"
                        label="Customer Unit Number"
                        additionalClass="w-full flex-grow"
                        error={
                            touched['customerUnitNumber'] && errors['customerUnitNumber']
                        }
                    />
                    <DropDown
                        {...getFieldProps('class')}
                        data={classOptions}
                        keyId="value"
                        keyToShow="value"
                        keyToFind="value"
                        setSelectedValue={val =>
                            setFieldValue('class', val?.value)
                        }
                        selected={
                            classOptions?.find(i => i?.value === values?.class) ||
                            null
                        }
                        placeholder="Select Class"
                        label="Class"
                        className="w-full flex-grow z-120"
                        required
                        isSmall
                        error={touched['class'] && errors['class']}
                    />
                </div>
                {!isMobile && <CustomDivider />}
                <div className="w-full flex  lg:flex-row flex-col items-center justify-between gap-x-8 gap-y-1">
                    <DropDownWithSearch
                        data={manufacturerOptions}
                        keyId="value"
                        keyToShow="value"
                        keyToFind="value"
                        setSelectedValue={val =>
                            setFieldValue('manufacturer', val?.value)
                        }
                        selected={
                            manufacturerOptions?.find(i => i?.value === values?.manufacturer)
                            || null
                        }
                        placeholder="Select Manufacturer"
                        label="Manufacturer"
                        className="w-full flex-grow"
                        required
                        isSmall
                        searchMessage="Your manufacturer isn't listed?"
                        searchPlaceholder="Please enter your manufacturer"
                        setIsFromList={setMakeOffList}
                        error={
                            touched['manufacturer'] && errors['manufacturer']
                        }
                    />
                    <DropDownWithSearch
                        data={modelOptions}
                        keyId="value"
                        keyToShow="value"
                        keyToFind="value"
                        setSelectedValue={val =>
                            setFieldValue('model', val?.value)
                        }
                        selected={
                            modelOptions?.find(
                                i => i?.value === values?.model,
                            ) || null
                        }
                        placeholder="Select Model"
                        label="Model"
                        className="w-full flex-grow"
                        required
                        isSmall
                        disabled={disableModelInput}
                        disabledMessage={"Please select a Manufacturer first."}
                        searchMessage="Your model isn't listed?"
                        searchPlaceholder="Please enter your model"
                        isDisableList={!isModelFromList}
                        setIsFromList={setModelOffList}
                        error={
                            touched['model'] && errors['model']
                        }
                    />
                </div>
                {!isMobile && <CustomDivider />}
                <div className="w-full flex  lg:flex-row flex-col items-start justify-between gap-x-8 gap-y-1">
                    <InputText
                        placeholder="Serial Number"
                        label="Serial Number"
                        additionalClass="lg:rowRentalItem w-full flex-grow"
                        error={
                            touched['serialNumber'] && errors['serialNumber']
                        }
                        isRequired
                        {...getFieldProps('serialNumber')}
                    />
                    <DropDown
                        data={fuelTypeOptions}
                        keyId="value"
                        keyToShow="value"
                        keyToFind="value"
                        setSelectedValue={val =>
                            setFieldValue('fuelType', val?.value)
                        }
                        selected={
                            fuelTypeOptions?.find(
                                i => i?.value === values?.fuelType,
                            ) || null
                        }
                        placeholder="Select Fuel Type"
                        label="Fuel Type"
                        className="w-full flex-grow"
                        required
                        isSmall
                        error={
                            touched['fuelType'] && errors['fuelType']
                        }
                    />
                </div>
                {!isMobile && <CustomDivider />}
                <div className="w-full flex  lg:flex-row flex-col items-start justify-between gap-x-8 gap-y-1">
                    <DropDown
                        customRender={({ label, address }) => (
                            <CellLocation
                                isInCard
                                label={label}
                                address={address}
                            />
                        )}
                        data={formattedShiptos}
                        keyId="value"
                        keyToShow="locationToShow"
                        keyToFind="address"
                        setSelectedValue={val =>
                            setFieldValue('shipToId', val?.value)
                        }
                        selected={
                            formattedShiptos?.find(
                                i => i?.value === values?.shipToId,
                            ) || null
                        }
                        placeholder="Select Location"
                        isSmall={!values?.shipToId}
                        label="Location"
                        className="lg:rowRentalItem w-full flex-grow"
                        required
                        error={touched['shipToId'] && errors['shipToId']}
                    />
                    <InputText
                        placeholder="Add any additional details"
                        label="Additional Details"
                        type="textarea"
                        additionalClass="lg:rowRentalItem w-full flex-grow"
                        error={
                            touched['additionalDetails'] && errors['additionalDetails']
                        }
                        {...getFieldProps('additionalDetails')}
                    />
                </div>
            </div>
        )
    }

    return (
        <form
            autoComplete="off"
            className="w-full h-full min-w-full min-h-full flex flex-col items-center justify-start"
            onSubmit={handleSubmit}
        >
            <ContentLayout>
                <MainHeading
                    title="Add Asset Manually"
                    actions={[
                        <Button
                            key="cancelButton"
                            variant="tertiary"
                            text="Cancel"
                            onClick={() => {
                                history?.goBack()
                            }}
                            className="lg:w-auto w-full flex-grow"
                            type="button"
                        />,
                        <Button
                            key="addAssetButton"
                            variant="primary"
                            text="Add Asset"
                            className="lg:w-auto w-full flex-grow"
                            disabled={
                                !isValid ||
                                impersonatedBy === 'salesperson' ||
                                hasPendingUploads
                            }
                            type="submit"
                        />,
                    ]}
                />
                <div className="w-full h-full overflow-auto flex flex-col items-center justify-start max-w-full max-h-full lg:px-6 px-4 lg:py-12 py-6">
                    <div className="lg:w-220 w-full h-auto ">
                        <CardInfo
                            hasPaddingContent={false}
                            title="Asset Details"
                            isOverflowVisible={true}
                            content={renderForm()}
                        />
                    </div>
                </div>
            </ContentLayout>
        </form>
    )
}

CreateAssetPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
        goBack: PropTypes.func,
    }),
    error: PropTypes.string,
    location: PropTypes.shape({
        state: PropTypes.object,
    }),
}

export default CreateAssetPage
